import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { GOOGLE_CLIENT_ID } from '@constants';
import { Box } from '@mui/material';
import { CredentialResponse, GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { errorHandler, getStorageItem } from 'helpers';
import { useAppDispatch } from 'hooks';
import { usersOp } from 'store/users';
import { Typography } from 'ui-kit';

import logo from '.././LeftPanel/logo.jpg';

export const Login = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const accessToken = getStorageItem('access_token');

    const handleSuccess = (response: CredentialResponse) => {
        dispatch(usersOp.validateUser({ platform: 'GOOGLE', token: response.credential as string }, navigate));
    };

    const handleError = () => {
        errorHandler('Google Login Failed', dispatch);
    };

    useEffect(() => {
        if (accessToken) {
            navigate('/admin-panel');
        }
    }, [accessToken]);

    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID as string}>
            <Box display="flex" flexDirection="column" gap={4} alignItems="center" justifyContent="center" height={1}>
                <img src={logo} alt="logo" width={200} height={200} />
                <Typography variant="h5" align="center">
                    {t('welcome.to.fayton')}
                </Typography>
                <Box width={200}>
                    <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
                </Box>
            </Box>
        </GoogleOAuthProvider>
    );
};
